module.exports = __webpack_public_path__ + "img/guide_dir_05.36144a19.png";